export default __webpack_public_path__ + "static/proximity-dont-0b8d83cecbf90f68efe163f857fff02cc96b77d35075bf17edbd986b62ebc195.png";